// Re-exports with async fetch wrappers for use with react-query
export { fetchFighterJets } from './conflict-zones';
import { CONFLICT_ZONES, DRONE_ZONES, NUCLEAR_ASSETS } from './conflict-zones';

export function fetchConflictZones() {
  return CONFLICT_ZONES;
}

export function fetchDroneZones() {
  return DRONE_ZONES;
}

export function fetchNuclearAssets() {
  return NUCLEAR_ASSETS;
}
